<div class="flex-row justify-content-space-between align-items-center mb-10">
  <button
    class="drawer-action-button"
    mat-button
    (click)="back()"
  >
    <mat-icon>arrow_back</mat-icon> <span class="button-label">Cancel</span>
  </button>

  @if (isSaving) {
    <mat-spinner [diameter]="20" class="m-10"></mat-spinner>
  } @else {
    <button
      mat-icon-button
      (click)="save()"
      [disabled]="!canSave()"
      matTooltip="Save"
    >
      <mat-icon>save</mat-icon>
    </button>
  }
</div>

<mat-form-field>
  <mat-label>Observation Type Group</mat-label>
  <input
    matInput
    [(ngModel)]="observation.observationType.group.name"
    [disabled]="true"
  />
</mat-form-field>

<mat-form-field>
  <mat-label>Observation Type</mat-label>
  <mat-select
    [(ngModel)]="observationTypeId"
    (ngModelChange)="typeChanged($event)"
  >
    @for (type of observationTypes; track $index) {
      <mat-option [value]="type.id">{{ type.title }}</mat-option>
    }
  </mat-select>
</mat-form-field>

<p>
  Click anywhere on the map to move this observation
</p>
